/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * List of inventory statuses
 */
export type InventoryStatus = (typeof InventoryStatus)[keyof typeof InventoryStatus];

export const InventoryStatus = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const;
